import React from 'react';
import useBreakpoints from '@hooks/useBreakpoints';
import useId from '@hooks/useId';

function CventSVG({ color, small }: { color?: string; small?: boolean }): JSX.Element {
  const { isDefaultSize, isS } = useBreakpoints();
  const labelledBy = useId();

  return (
    <svg
      id="a"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 498.41 104.51"
      width={isS || isDefaultSize || small ? '85' : '156'}
      height={isS || isDefaultSize || small ? '20' : '40'}
      aria-labelledby={labelledBy}
      role="img"
    >
      <title id={labelledBy}>C vent</title>
      <g>
        <path
          fill={color || '#221e1f'}
          d="M186.79,35.22h22.05l-45.57,67.7h-7.19L109.42,35.22h22.28l28.06,42.54,27.04-42.54Z"
        />
        <path
          fill={color || '#221e1f'}
          d="M303.55,70.78l-74.55,.07c0,5.99,4.97,11.8,11.46,14.56,9.17,3.91,14.58,4.25,25.14,4.25,13.89,0,25.14-2.63,36.39-8.27v13.96c-7.34,4.93-21.27,8.95-39.77,8.95-12.41,0-23.28-1.31-30.92-4.88-7.51-3.51-11.35-6.23-15.29-12.06-3.73-5.53-6.13-11.94-6.13-18.93,0-10.48,4.28-18.44,12.1-25.4,8.74-7.78,21.71-10.02,37.24-10.02s26.18,4.31,34.24,11.71c8.32,7.64,10.1,16.47,10.1,24.33v1.72Zm-72.89-12.36l53.16-.06c-1.1-4.13-4.16-7.42-8.42-9.86-4.27-2.44-9.64-4.13-16.85-4.13s-12.8,1.19-17.96,3.81c-4.64,2.36-8.26,6.07-9.92,10.24Z"
        />
        <path
          fill={color || '#221e1f'}
          d="M338.75,35.22v8.49c9.5-6.66,21.16-9.99,32.83-9.99,6.48,0,12.5,1.09,18.08,3.27,5.57,2.18,9.06,5,11.74,8.97,2.86,4.22,4.35,9.81,4.35,18.05v38.66h-19.36v-35.47c0-6.9-2.67-11.86-5.91-14.83-3.24-2.96-8.62-4.87-16.23-4.87-9.72,0-18.5,3.66-25.52,9.99v45.18h-19.74V35.22h19.74Z"
        />
        <path
          fill={color || '#221e1f'}
          d="M413.81,46.01l33.61-32.11h1.17v19.35h26.33v15.21h-26.33v27.4c0,8.51,5.16,12.75,13.4,12.75,5.92,0,10.55-1.4,16.27-5.21v15.67c-6.84,3.39-11.88,4.75-20.64,4.75-7.95,0-11.96-1.3-17.83-5.23-1.84-1.19-3.4-2.93-4.6-4.41-1.2-1.48-2.37-3.67-3.19-6.06-.81-2.39-1.22-6.96-1.22-13.69v-25.96h-16.98v-2.45Z"
        />
        <path
          fill={color || '#1ca9e1'}
          d="M102.76,84.55v16.16c-10.86,2.53-21.48,3.8-31.85,3.8-17.12,0-29.76-3.18-39.43-9.54-9.67-6.36-14.08-14.88-14.08-25.57s4.13-19.77,13.55-26.38c9.41-6.61,21.58-9.62,37.76-9.62,5.63,0,10.68,.34,15.17,1.01,4.48,.67,10.01,1.92,16.6,3.77v16.48c-10.97-4.39-19.92-6.07-30.52-6.07-9.06,0-18.74,2.23-24.28,5.75-6.19,3.94-8.29,9.56-8.29,14.62,0,5.94,3.47,11.02,9.16,14.59,6.06,3.81,17.46,5.57,27.52,5.57,8.33,0,17.89-1.52,28.69-4.56Z"
        />
        <path
          fill={color || '#221e1f'}
          d="M492.05,34.5c1.09,0,2.14,.27,3.14,.82,1,.55,1.79,1.33,2.36,2.35,.57,1.02,.86,2.08,.86,3.2s-.28,2.16-.84,3.17c-.56,1-1.34,1.79-2.35,2.35-1,.56-2.06,.84-3.17,.84s-2.16-.28-3.17-.84c-1-.56-1.79-1.34-2.35-2.35-.56-1-.84-2.06-.84-3.17s.29-2.18,.86-3.2c.57-1.02,1.36-1.8,2.36-2.35,1-.54,2.05-.82,3.14-.82Zm0,1.25c-.87,0-1.71,.22-2.51,.66-.8,.44-1.43,1.07-1.9,1.88-.46,.82-.69,1.68-.69,2.57s.23,1.74,.68,2.55c.45,.81,1.08,1.44,1.89,1.89,.81,.45,1.66,.68,2.54,.68s1.74-.23,2.54-.68c.81-.45,1.44-1.08,1.89-1.89,.45-.81,.68-1.66,.68-2.55s-.23-1.75-.69-2.57c-.46-.82-1.1-1.45-1.9-1.88-.81-.44-1.64-.66-2.52-.66Zm-2.88,8.52v-6.75h1.37c1.28,0,2,0,2.16,.02,.45,.04,.81,.13,1.06,.27,.25,.14,.46,.36,.63,.65,.17,.29,.25,.61,.25,.97,0,.49-.16,.9-.48,1.25-.32,.35-.76,.56-1.34,.64,.2,.08,.36,.16,.47,.25,.11,.09,.26,.26,.46,.52,.05,.07,.22,.34,.5,.82l.8,1.36h-1.69l-.56-1.1c-.38-.74-.7-1.2-.95-1.39-.25-.19-.56-.29-.95-.29h-.36v2.77h-1.37Zm1.37-3.83h.56c.79,0,1.28-.03,1.47-.09,.19-.06,.34-.17,.45-.32,.11-.15,.17-.32,.17-.52s-.05-.36-.16-.5c-.11-.15-.26-.25-.46-.32s-.69-.1-1.47-.1h-.56v1.84Z"
        />
      </g>
    </svg>
  );
}

export default CventSVG;
